import Dialog from 'components/Dialog';
import React from 'react';
import {Grid} from '@mui/material';
import FormikTextField from 'components/inputs/FormikTextField';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useDispatch, useSelector} from 'react-redux';
import {layoutActions} from 'features/layout/redux';
import {packId, unpackId} from 'common/diplomatIdUtil';
import {Trans, useTranslation} from 'react-i18next';
import selectors from 'features/layout/redux/selectors';
import {IDiplomatObject} from 'types/DiplomatObject';
import history from 'redux/history';
import {transactionsActions} from 'redux/transactions';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import Formik from 'components/hook-form/Formik';

const validationSchema = yup.object({
   transactionName: yup.string().required(),
});

type Props = {
   data?: INav;
   onClose: () => void;
};

const SaveTransactionAsDialog = ({data, onClose}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const transactions = useSelector(selectors.transactionsSelector);

   const {id, objectType} = unpackId(data?.id);
   const saveAs = React.useCallback(
      ({transactionName}) => {
         dispatch(
            transactionsActions.saveAs(id, objectType, transactionName, {
               onSuccess: (data: ITransaction) => {
                  dispatch(layoutActions.loadTreeNav());
                  onClose();
                  history.push(`/${packId(data.objectType, data.id)}`);
               },
               onFailure: onClose,
            })
         );
      },
      [dispatch, id, objectType, onClose]
   );

   const transactionName = t('transaction');

   const validateName = (value: string) => {
      const isNameExists = transactions.some((obj: IDiplomatObject) => obj.name === value);
      if (isNameExists) {
         return t(`Diplomat already contains a {{transactionName}} named {{name}}`, {
            transactionName,
            name: value,
         });
      }
   };

   return (
      <Dialog maxWidth="sm" header={t('Save Transaction As')} close={onClose}>
         <Formik
            initialValues={validationSchema.cast({transactionName: data?.name})}
            onSubmit={saveAs}
         >
            <>
               <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={8}>
                     <FormikTextField
                        autoFocus
                        type="text"
                        name="transactionName"
                        label={t('New {{transactionName}} Name:', {transactionName})}
                        required
                        validate={validateName}
                     />
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                  <FormFooterButtons cancel={onClose} />
               </Grid>
            </>
         </Formik>
      </Dialog>
   );
};

export default SaveTransactionAsDialog;
